export default function () {
    return {
        banners: []
    }
}